import {
  defaultCard,
  defaultCardWithContent,
  defaultMobileCard,
} from "src/components/shared/Cards/sharedStyles";
import { ReactComponent as Eye } from "src/images/spectatorIcon.svg";
import styled from "styled-components";

export const SpectatorCardElement = styled.div`
  ${defaultMobileCard}
  ${defaultCardWithContent}

  border: ${({ theme }) => theme.border.thin} dashed
    ${({ theme }) => theme.colors.cards.borders.secondary};

  background-color: ${({ theme }) => theme.colors.cards.fills.spectator};

  @media ${({ theme }) => theme.mq.md} {
    ${defaultCard}
  }
`;

export const SpectatorIcon = styled(Eye)`
  height: 24px;
  width: 24px;

  @media ${({ theme }) => theme.mq.md} {
    height: 32px;
    width: 32px;
  }
`;
